import ElectronicBillingHTTP from './ElectronicBillingHTTP';

class IFacturaAppHTTP {

    checkStatus(response) {
        switch (response.status) {
            case 500:
                throw new Error(`${response.status} - Server Error!`);
            case 403:
                throw new Error(`${response.status} - Unhautorized!`);
            default:
                break;
        }
    }

    async getToken() {
        let token = null;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/login-talum`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        })
            .then(data => {
                console.log(data);
                token = data.data.tokenOperacion;
            })
            .catch((error) => {
                token = null;
            });
        return token;
    }

    //Genera el JSON de Facturacion Electronica en Salud con iFacturaApp
    async generateHealthInvoiceJSONTalumm(id_factura) {
        let dataJSON = null;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/generar-json-ifacturaapp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_factura_t: id_factura,
                id_clinica: sessionStorage.getItem('id_clinica')
            })
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            dataJSON = data;
        }).catch((error) => {
            dataJSON = null
        });
        return dataJSON;
    }

    //Facturas en Salud
    async importInvoiceiFacturaApp(id_factura) {
        let invoiceHTTP = null;
        //let token = await this.getToken();
        let sendData = {
            //talum_token: token,
            id_factura: id_factura,
            id_clinica: sessionStorage.getItem('id_clinica')
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/importar-facturas-ifacturaapp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(sendData)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        })
            .then(data => {
                console.log(data)
                invoiceHTTP = data;
                if (data.statuCode == 403 || data.statuCode == 500) {//Si la DIAN lo rechazo o hubo un error
                    throw new Error('Ocurrio un error con la Facturación Electronica');
                }
                else {
                    console.log("Succesful", data.data.cufe)
                    if (!!data.data.cufe)
                        ElectronicBillingHTTP.saveCUFE(data.data.cufe, id_factura);
                }
            })
            .catch((error) => {
                throw new Error('Ocurrio un error con la Facturación Electronica');
            });
        return invoiceHTTP;
    }

    async importComercialInvoiceiFacturaApp(id_factura) {
        let invoiceHTTP = null;
        //let token = await this.getToken();
        let sendData = {
            //talum_token: token,
            id_factura: id_factura,
            id_clinica: sessionStorage.getItem('id_clinica')
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/importar-facturas-comercial-ifacturaapp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(sendData)
        }).then(response => {
            console.log({ responseiFacturaApp: response })
            //this.checkStatus(response);
            return response.json();
        }).then(data => {
            console.log({ dataIFacturaApp: data })
            invoiceHTTP = data;
            if (data.statuCode !== 500) {//Si la DIAN lo rechazo o hubo un error
                console.log("Succesful", data.data.cufe)
                if (!!data.data.cufe)
                    ElectronicBillingHTTP.saveCUFE(data.data.cufe, id_factura);
            }
        }).catch((error) => {
            console.log({ errorFront: error })
            throw new Error('Ocurrio un error con la Facturación Electronica');
        });
        return invoiceHTTP;
    }

    async downloadXMLiFacturaApp(data, factura) {
        let sendData = {
            prefijo: data.split("-")[0],
            folio: data.split("-")[1]
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/descargar-xml-ifacturaapp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(sendData)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            const fileName = `XML ${sendData.prefijo + sendData.folio}.xml`;
            const linkSource = `data:application/xml;base64,${data.filebase64}`;
            const downloadLink = document.createElement('a');
            document.body.appendChild(downloadLink);
            downloadLink.href = linkSource;
            downloadLink.target = '_self';
            downloadLink.download = fileName;
            downloadLink.click();
        }).catch((error) => {
            console.log({error})
            token = null;
        });
    }

    async downloadPDFiFacturaApp(data) {
        let sendData = {
            prefijo: data.split("-")[0],
            folio: data.split("-")[1]
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/descargar-pdf-ifacturaapp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(sendData)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            console.log("DATAPDF", data);
            const fileName = `PDF ${sendData.prefijo + sendData.folio}.pdf`;
            const linkSource = `data:application/pdf;base64,${data.filebase64}`;
            const downloadLink = document.createElement('a');
            document.body.appendChild(downloadLink);
            downloadLink.href = linkSource;
            downloadLink.target = '_self';
            downloadLink.download = fileName;
            downloadLink.click();
        }).catch((error) => {
            token = null;
        });
    }

    async downloadPDFNCSiFacturaApp(folio_nota_c) {
        let sendData = {
            folio_nota_c
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/descargar-pdf-ncs-ifacturaapp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(sendData)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            console.log("DATAPDF", data);
            const fileName = `PDF ${folio_nota_c}.pdf`;
            const linkSource = `data:application/pdf;base64,${data.filebase64}`;
            const downloadLink = document.createElement('a');
            document.body.appendChild(downloadLink);
            downloadLink.href = linkSource;
            downloadLink.target = '_self';
            downloadLink.download = fileName;
            downloadLink.click();
        }).catch((error) => {
            console.log({error})
        });
    }

    async sendEmailsiFacturaApp(factura) {
        let invoiceHTTP = null;
        let sendData = {
            prefijo: factura.prefijo,
            folio: factura.folio,
            emails: factura.emails
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/enviar-emails-ifacturaapp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(sendData)
        }).then(response => {
            console.log({response})
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            console.log({dataRequestEmail: data})
            invoiceHTTP = data;
        }).catch((error) => {
            console.log({error})
            token = null;
        });
        return invoiceHTTP;
    }

}

export default new IFacturaAppHTTP();
